import apolloClient from '../../utils/apollo-client';
import { profileSave as mutation } from '../../api/graphql/user';

export default async function saveUserProfile(profilePayLoad) {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: { profilePayLoad }
    })
  );
  return response.data.profileSave;
}
